import normalizeTeamsData from './normalizeTeamsData';

const mapIt = (team) => {
	const {
		pid: pid,
		id: id,
		entityName: entityName,		
		...rest
	} = team;

	return {
		...rest,
		pid,
		id,
		entityName,
	};
};

const filterTeams = (teams, searchString) =>
	teams.map((team) => {
		let filteredTeam = { ...team, visible: false };

		if (team?.children?.length > 0) {
			filteredTeam.children = [...filterTeams(team.children, searchString)];
		}

		const match =
			team?.entityName.toLowerCase().includes(searchString?.toLowerCase()) ||
			filteredTeam?.children?.some(({ visible }) => visible);

		if (match) return { ...filteredTeam, visible: true };
		return { ...filteredTeam, visible: false };
	});

const markAsLast = (list) => {
	const filteredList = list.filter(({ visible }) => visible);
	if (filteredList.length > 0) {
		const { id } = filteredList.pop();
		const markedList = list.map((item) => {
			const newItem = { ...item };
			if (item.id === id) newItem.last = true;
			if (item?.children?.length > 0) {
				newItem.children = markAsLast(item.children);
			}
			return newItem;
		});
		return markedList;
	}
	return list;
};

export default (teams) => markAsLast(filterTeams(normalizeTeamsData(teams.map(mapIt)),""));
